<nb-layout class="kwik-hub">
    <nb-layout-header fixed>
      <!-- <ubs-header [headerConfig]="siteHeader"></ubs-header> -->
    </nb-layout-header>
    <nb-layout-column>
        <div class="background-layer">
            <div class="content-layer">
                <div class="main-container">
                    <div class="hub-headline">
                        <nb-card>
                            <nb-card-body class="top-line">
                                <div class="left-back">
                                    <div class="info">
                                        <pl-sales-orders-summary></pl-sales-orders-summary>
                                    </div>
                                    <svg width="200" height="160" xmlns="http://www.w3.org/2000/svg">
                                        <!-- Square 1 (No rotation) -->
                                        <rect x="10" y="10" width="50" height="50" fill="red" />
                                        
                                        <!-- Square 2 (Slight rotation) -->
                                        <rect x="80" y="10" width="60" height="60" fill="blue" transform="rotate(15 110 40)" />
                                        
                                        <!-- Square 3 (No rotation) -->
                                        <rect x="10" y="80" width="40" height="40" fill="green" />
                                        
                                        <!-- Square 4 (Slight rotation) -->
                                        <rect x="80" y="80" width="70" height="70" fill="orange" transform="rotate(-10 115 115)" />
                                        </svg>
                                </div>
                                <div class="content-layer">
                                    <div class="h1">KwikHub</div>
                                </div>
                                <div class="right-back">
                                    <svg width="200" height="160" xmlns="http://www.w3.org/2000/svg">
                                        <!-- Square 1 (No fill, red border) -->
                                        <rect x="10" y="10" width="50" height="50" fill="none" stroke="red" stroke-width="3"/>
                                        
                                        <!-- Square 2 (No fill, blue border, slightly rotated) -->
                                        <rect x="80" y="10" width="50" height="50" fill="none" stroke="blue" stroke-width="3" transform="rotate(15 105 35)" />
                                        
                                        <!-- Square 3 (No fill, green border) -->
                                        <rect x="10" y="80" width="50" height="50" fill="none" stroke="green" stroke-width="3"/>
                                        
                                        <!-- Square 4 (No fill, orange border, slightly rotated) -->
                                        <rect x="80" y="80" width="50" height="50" fill="none" stroke="orange" stroke-width="3" transform="rotate(-10 105 105)" />
                                    </svg>
                                    <div class="info">
                                        <pl-sales-orders-graphs></pl-sales-orders-graphs>
                                    </div>    
                                </div>
                            </nb-card-body>
                        </nb-card>
                    </div>
                    <div class="site-selector">
                        <nb-card>
                            <nb-tabset fullWidth>
                                <nb-tab tabTitle="To Do's">
                                 <nb-menu [items]="quickTasks"></nb-menu>
                                </nb-tab>
                                <nb-tab tabTitle="Applications">
                                    <nb-menu [items]="appMenuItems"></nb-menu>
                                </nb-tab>
                              </nb-tabset>
                        </nb-card>
                    </div>
                    <div class="site-actions">
                        <nb-card>
                            <!-- <nb-card-header>
                                Actions
                            </nb-card-header> -->
                            <nb-card-body>
                                <div class="actions-grid">
                                    <div class="store-cell action-cell">
                                        <nb-card>
                                            <nb-card-header>Store Management</nb-card-header>
                                            <nb-card-body class="flash-body">
                                                <div class="horizontal four-cell">
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Inventory</div>
                                                        <div class="cell-content">
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    Inventory Items
                                                                </div>
                                                                <div class="item-value">
                                                                    500
                                                                </div>
                                                            </div>
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    Stock On Hand
                                                                </div>
                                                                <div class="item-value">
                                                                    3000
                                                                </div>
                                                            </div>
                                                           <!--  <ul class="flex-list">
                                                                <li>Naming</li>
                                                                <li>Inventory</li>
                                                                <li>Cart</li>
                                                                <li>Shipping</li>
                                                                <li>Payments</li>
                                                                <li>Tax</li>
                                                            </ul> -->
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Catalog</div>
                                                        <div class="cell-content">
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # Top Level Categories
                                                                </div>
                                                                <div class="item-value">
                                                                    5
                                                                </div>
                                                            </div>
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # Primary Product Categories
                                                                </div>
                                                                <div class="item-value">
                                                                    20
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Products</div>
                                                        <div class="cell-content">
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # Unique SKU's
                                                                </div>
                                                                <div class="item-value">
                                                                    300
                                                                </div>
                                                            </div>
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # Product Variants
                                                                </div>
                                                                <div class="item-value">
                                                                    120
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Shipping</div>
                                                        <div class="cell-content">
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # OutGoing
                                                                </div>
                                                                <div class="item-value">
                                                                    500
                                                                </div>
                                                            </div>
                                                            <div class="content-item">
                                                                <div class="item-label">
                                                                    # Incoming
                                                                </div>
                                                                <div class="item-value">
                                                                    110
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </nb-card-body>
                                        </nb-card>
                                    </div>
                                    <div class="product-cell action-cell">
                                        <nb-card>
                                            <nb-card-header>Product Management</nb-card-header>
                                            <nb-card-body class="flash-body">
                                                <div class="grid-display">
                                                    <pl-sales-by-period-graphs></pl-sales-by-period-graphs>
                                                    <!-- <div class="inner-cell">
                                                        <div class="cell-head">Products</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Add products</li>
                                                                <li>Product Content</li>
                                                                <li>Product Price</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Features</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Feature Groups</li>
                                                                <li>Standard Features</li>
                                                                <li>Selectable Features</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Configurations</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Configurable Items</li>
                                                                <li>Options</li>
                                                                <li>Option price</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Price Rules</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Price Variations</li>
                                                                <li>Rules setting</li>
                                                                <li>Geographical, Quanity, Time</li>
                                                            </ul>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </nb-card-body>
                                        </nb-card>
                                    </div>
                                    <div class="cms-cell action-cell">
                                        <nb-card>
                                            <nb-card-header>Content Management</nb-card-header>
                                            <nb-card-body class="flash-body">
                                                <div class="horizontal three-cell">
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Visual Editor</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Templates</li>
                                                                <li>Themes</li>
                                                                <li>Typography</li>
                                                                <li>Layouts</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Image Management</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Product Galleries</li>
                                                                <li>Blog Images</li>
                                                                <li>Newsletter Images</li>
                                                                <li>Upload Pictures</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Review</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Manage Product Reviews</li>
                                                                <li>Moderate Review</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </nb-card-body>
                                        </nb-card>
                                    </div>
                                    <div class="marketing-cell action-cell">
                                        <nb-card>
                                            <nb-card-header>Marketing</nb-card-header>
                                            <nb-card-body class="flash-body">
                                                <div class="horizontal three-cell">
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Promos</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Promotional Campaigns</li>
                                                                <li>Coupons</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Newletter</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Email Marketing Campaigns</li>
                                                                <li>Contact Lists</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="inner-cell">
                                                        <div class="cell-head">Surveys</div>
                                                        <div class="cell-content">
                                                            <ul class="flex-list">
                                                                <li>Create Online Surveys</li>
                                                                <li>Manage Surveys</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </nb-card-body>
                                        </nb-card>
                                    </div>
                                </div>
                            </nb-card-body>
                        </nb-card>
                    </div>
                </div>
            </div>
        </div>
      <!-- <router-outlet></router-outlet> -->
    </nb-layout-column>
    <nb-layout-footer>
        <!-- <ubs-footer [footerConfig]="siteFooter"></ubs-footer> -->
    </nb-layout-footer>
  </nb-layout>
